jQuery(document).ready(function ($) {

	function headerContentAppend() {
		if ($(window).width() <= 685) {
			$(".header-top .header-top-inner .header-button").appendTo(".mobile-navigation .menu-wd-header-navigation-container");
		} else {
			$(".mobile-navigation .menu-wd-header-navigation-container .header-button").appendTo(".header-top .header-top-inner");
		}

		if ($(window).width() <= 420) {
			$(".header-top .header-top-inner .header-cart, .header-top .header-top-inner .header-icons").appendTo(".header-middle .theme-container");
		} else {
			$(".header-middle .theme-container .header-cart, .header-middle .theme-container .header-icons").appendTo(".header-top .header-top-inner");
		}
	}

	$(window).load(headerContentAppend).resize(headerContentAppend).on("scroll", floatingButton).on("scroll", topMenu);

	function floatingButton() {
		const stickyBtn = $(".sticky-btn"),
			top = $(document.body).children(0).position().top,
			scrollTop = $(window).scrollTop();

		if (scrollTop === top) {
			stickyBtn.removeClass("is-active");
		} else {
			stickyBtn.addClass("is-active");
		}
	}

	//number of pixels before modifying styles

	function topMenu() {
		const breakPoint = 140,
			headerTop = $(".header-top"),
			headerMiddle = $(".header-middle"),
			headerTopbarMessage = $(".header-topbar-message");

		if ($(window).width() <= 979) {
			if ($(window).scrollTop() > 0) {
				headerTop.css({"top": headerTopbarMessage.outerHeight() + "px"});
				headerTopbarMessage.addClass("sticky-header");
			} else {
				headerTop.css({"top": 0 + "px"});
				headerTopbarMessage.removeClass("sticky-header");
			}
		} else {
			if ($(window).scrollTop() > breakPoint) {
				headerMiddle.css({"top": headerTopbarMessage.outerHeight() + "px"});
				headerTopbarMessage.addClass("sticky-header");
			} else {
				headerMiddle.css({"top": 0 + "px"});
				headerTopbarMessage.removeClass("sticky-header");
			}
		}
	}

});